export const regexpSubwayMoverTypeExist = / пешком| на транспорте/gi;

export enum EMovingType {
  Walk = 'walk',
  Transport = 'transport',
}

export const CLASS_NAME_CAROUSEL_END = 'pik-plus-carousel--end';

export const SWIPER_OPTIONS = {
  spaceBetween: 6,
  slidesPerView: 2.3,
  navigation: true,
};
